import axios from 'axios'
import {store} from "../storage";

const url = 'http://10.1.110.121:8000/proyectos'
axios.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('t');
const state = {
  endpoints: {
    area: url + '/area/',
    financiera: url + '/financiera/',
    investigador: url + '/investigador/',
    proyectos: url + '/proyecto/'
  },
  proyectos: [],
  areas: [],
}

const mutations = {
  /**PROYECTOS**/
  async listarProyectos(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.proyectos, {
      headers: {
      },
    }).then((response) => {
      state.proyectos = response.data
    }).catch(error => {
      state.proyectos = []
    })
  },
  /**AREAS**/
  async listarAreas(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.area, {
      headers: {
      },
    }).then((response) => {
      state.areas = response.data
    }).catch(error => {
      state.areas = []
    })
  },
}

const actions = {
  /**PROYECTOS**/
  getProyectos({commit}) {
    commit('listarProyectos')
  },
  /**Areas**/
  getAreas({commit}) {
    commit('listarAreas')
  },
}

const getters = {
  proyectos: (state) => state.proyectos,
  areas: (state) => state.areas,
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/storage/modules/proyectos.js